import enquire from 'enquire.js';
import { tns } from 'tiny-slider/src/tiny-slider';
import { theme } from '@/utilities';

const container = document.querySelector('.js-related-content');
let slider;

if (container) {
    enquire.register(`screen and (max-width: ${theme.screens.md})`, {
        match: function () {
            if (!slider.getInfo) slider = slider.rebuild();
        },

        unmatch: function () {
            slider.destroy();
        },

        setup: function () {
            slider = tns({
                container: container,
                items: 1,
                responsive: {
                    640: {
                        items: 2
                    }
                },
                autoplay: true,
                edgePadding: 40,
                gutter: 20,
                controls: false,
                slideBy: 'page',
                nav: false,
                autoplayButtonOutput: false,
                mouseDrag: true
            });
        },

        deferSetup: true,

        destroy: function () {
            slider.destroy();
        }
    });
}
